ready(function(){
	const sliderHome = document.querySelector('.glide.type--home');
	if (sliderHome) {
		const sliderHomeOptions = {
			type: 'slider',
			perView: 1,
			gap: 1,
			bound: true,
			animationDuration: 800,
			autoplay: 6000,
		};
	  new Glide('.glide.type--home', sliderHomeOptions).mount();
	}
});